// extracted by mini-css-extract-plugin
module.exports = {"guide":"ViewOffer_guide__1SesW","intro_1":"ViewOffer_intro_1__fL8Je","intro":"ViewOffer_intro__3Ltya"};